<template>
  <div id="subscriptionGuide" :key="new Date().getTime()" :style="`top:${top}px; left:${left}px`" class='tp-popover' v-if="show">
    <header class="tp-popover__header" style='${topStyle}'>
      <span class="tp-popover__header--title">{{title}}</span>
      <span style='cursor: pointer;' @click="close">
        <svg-icon style="color: #fff; width: 30px;" name="close3" ></svg-icon>
      </span>
    </header>
    <main class="tp-popover__main">{{content}}</main>
      <footer class="tp-popover__footer">
          <span style='color: #fff'>{{count}}/3</span>
            <button id='clickBtn' style='${footerButtonStyle}' @click="nextButtonClick">{{confirmText}}</button>
      </footer>
    </div>
</template>
<script>
import { updateDialerGuide } from '@/api/user.js'
import { mapActions, mapState } from "vuex";
export default {
  props: {
    top: {
      type: Number,
      default: 0
    },
    left: {
      type: Number,
      default: 0
    },
    count: {
      type: Number,
      default: 1
    },
    dialerSubscriptionCountKey: {
      type: String,
      default: ''
    },
    subscriptionCountKey: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    removeEl: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: 'Next'
    }
  },
  data() {
    return {
      show: true,
      calcLeft: 0,
      clearTime: null
    }
  },
  watch: {
    isActive: {
      handler(value) {
        this.show = value
      },
      immediate: true
    },
  },
  computed: {
    ...mapState({
      subscriptionCount: state => state.user.subscriptionCount.subscriptionCount,
      dialerSubscriptionCount: state => state.user.subscriptionCount.dialerSubscriptionCount,
    })
  },
  methods: {
     ...mapActions({
      recordClickCount: 'user/recordClickCount'
    }),
    nextButtonClick() {
      if(this.dialerSubscriptionCountKey) {
        this.show = false
        this.recordClickCount(this.dialerSubscriptionCountKey)
      }
      if(this.subscriptionCountKey) {
        this.recordClickCount(this.subscriptionCountKey)
        if(this.subscriptionCount > 3 ) {
          this.show = false
          sessionStorage.setItem(this.subscriptionCountKey, this.subscriptionCountKey)
        }
      }
    },
    close() {
      if(this.dialerSubscriptionCountKey) {
        updateDialerGuide()
        this.recordClickCount(this.dialerSubscriptionCountKey)
        sessionStorage.setItem(this.dialerSubscriptionCountKey, this.dialerSubscriptionCountKey)
      }
      if(this.subscriptionCountKey) {
        this.recordClickCount(this.subscriptionCountKey)
        sessionStorage.setItem(this.subscriptionCountKey, this.subscriptionCountKey)
      }
      this.show = false
    }
  },
  mounted() {
    if(this.dialerSubscriptionCountKey) {
      this.$nextTick(() => {
        window.addEventListener('resize', (e) => {
          this.left = e.currentTarget.innerWidth - (this.dialerSubscriptionCount === 3 ? 412 : 375)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tp-popover {
  position: absolute;
  width: 332px;
  padding: 24px;
  z-index: 999;
  background: #395BBE;
  border-radius: 6px;
  transition: 1s;
  &::before {
    position: absolute;
    content: "";
    width: 10px;
    height: 10px;
    top: -10px;
    left: 45%;
    border-right: solid 10px transparent;
    border-left: solid 10px transparent;
    border-bottom: solid 10px #395BBE;
  }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &--title {
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      font-family: OpenSans;
      color: #FFFFFF;
    }
  }
  &__main {
    font-family: OpenSans;
    margin-bottom: 16px;
    overflow: hidden;
    white-space: initial;
    color: #ffff;
  }
  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    button {
      width: 80px;
      height: 32px;
      background: #FFFFFF;
      border-radius: 4px;
      outline: none;
      border: none;
      font-weight: 700;
      font-size: 12px;
      line-height: 22px;
      cursor: pointer;
      text-transform: uppercase;
      color: #4066D4;
    }
  }
}

</style>